import React from 'react';
import { FiCamera, FiCheckCircle, FiCpu, FiUploadCloud } from 'react-icons/fi';
import ProductsHero from '../components/ProductsHero/ProductsHero';
import ProductFlowDiagram from '../components/ProductFlowDiagram/ProductFlowDiagram';
import ProductModuleContent from '../components/ProductModuleContent/ProductModuleContent';
import ProductModulePricing from '../components/ProductModulePricing/ProductModulePricing';
import './Products.css';

const SIX_BOXES = [
  {
    title: 'AI Based Bill Processing',
    description: 'Scanned or photo of bills converted into direct entry to your Accounting system using AI.',
  },
  {
    title: 'Direct Push to Accounting Platform',
    description: 'Snap Bill transfers your copy of the bill and all data into your Accounts platform in one click. No additional effort required.',
  },
  {
    title: 'No Structural Changes',
    description: 'No Additional setup or IT knowledge required. Accounting or Admin person can process all bills.',
  },
  {
    title: 'Avoid Human Errors',
    description: 'AI based conversion reduces data entry errors that goes unnoticed for a longer period. Snap Bill is capable of capturing TAX/VAT details from the bill.',
  },
  {
    title: 'Auto Generate LPO',
    description: 'Upload estimates/quotations received from your vendors/suppliers and generate LPO in seconds, avoiding manual data entry in your accounting system.',
  },
  {
    title: 'AI Based SOA verification',
    description: 'Accurate verification of SOA against your accounting platform data, providing line by line inputs and mismatches. Get summary details for sharing.',
  },
];

const FLOW_STEPS = [
  { title: 'Scan bills / use soft copy', icon: <FiCamera /> },
  { title: 'Snap Bill AI Processing', icon: <FiCpu /> },
  { title: 'Verify and Update if required', icon: <FiCheckCircle /> },
  { title: 'Pushes to Zoho in real time', icon: <FiUploadCloud /> },
];

const FEATURES = [
  'Faster data entry',
  'Less manual work',
  'Less Human Error',
  'Faster TAT for LPO and SOA',
  'AI driven data capture and verification',
  'Cost saving',
  'No setup or updates to existing platform',
  'No IT knowledge required',
  'Pay only for what you use',
];

const ProductsSnapBill = () => (
  <div className="products-page">
    <ProductsHero title="Snap Bill" bannerSection="Products > Snap Bill">
      <p className="text-muted">
        Is your team spending considerable amount of time for manually entering vendor/supplier bills into your
        accounting system? Using Artificial Intelligence (AI) and financial understanding, Snap Bill allows you
        to automate bill entries, generation of LPO from estimate/quote and auto verification of SOA. All this
        in few seconds!
      </p>
      <p className="text-muted">
        Snap Bill also publishes the records in real time to Zoho Books, including the scanned documents. What
        takes days is now done in minutes! No structural changes or IT knowledge required. All you do is connect
        your accounting system to flowdo without entering your Zoho credentials.
      </p>
    </ProductsHero>
    <ProductModuleContent
      sixBoxes={SIX_BOXES}
      afterBoxes={<ProductFlowDiagram steps={FLOW_STEPS} />}
      features={FEATURES}
    />
    <ProductModulePricing
      moduleKey="invoice_scanner"
      moduleLabel="Snap Bill"
      registerModule="invoice_scanner"
    />
  </div>
);

export default ProductsSnapBill;
